"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var evolve_emitter_1 = __importDefault(require("../emitters/evolve-emitter"));
var color_1 = require("../utilities/color");
var stack_container_1 = __importStar(require("../views/stack-container"));
var game_area_1 = require("../utilities/game-area");
var calculator_1 = require("../models/calculator");
var gsap_1 = require("gsap");
var i18next_1 = __importDefault(require("i18next"));
var guide_1 = require("../models/guide");
var guide_state_1 = __importDefault(require("./guide-state"));
var HatchState = /** @class */ (function (_super) {
    __extends(HatchState, _super);
    function HatchState(app, client, guide, backdropContainer, dragonContainer) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        _this._guide = guide;
        _this._backdropContainer = backdropContainer;
        _this._dragonContainer = dragonContainer;
        return _this;
    }
    Object.defineProperty(HatchState.prototype, "evolveEmitter", {
        get: function () {
            if (!this._evolveEmitter) {
                this._evolveEmitter = new evolve_emitter_1.default();
            }
            return this._evolveEmitter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HatchState.prototype, "titleLabel", {
        get: function () {
            if (!this._titleLabel) {
                this._titleLabel = new PIXI.Text("");
                this._titleLabel.style = {
                    fontFamily: "Arial",
                    fontWeight: "bold",
                    align: "center",
                    fontSize: 35,
                    fill: color_1.COLOR.WHITE
                };
            }
            return this._titleLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HatchState.prototype, "tipLabel", {
        get: function () {
            if (!this._tipLabel) {
                this._tipLabel = new PIXI.Text("");
                this._tipLabel.style = {
                    fontFamily: "Arial",
                    fontSize: 21,
                    fill: color_1.COLOR.GREEN
                };
            }
            return this._tipLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HatchState.prototype, "stackContainer", {
        get: function () {
            if (!this._stackContainer) {
                this._stackContainer = new stack_container_1.default([
                    this.titleLabel,
                    this.tipLabel
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 6,
                    minWidth: game_area_1.GAME_WIDTH
                });
                this._stackContainer.position.set(0, game_area_1.GAME_SAFE_AREA.bottom - this._stackContainer.height - 10);
            }
            return this._stackContainer;
        },
        enumerable: false,
        configurable: true
    });
    HatchState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this._backdropContainer);
        this._app.stage.addChild(this.evolveEmitter.parent);
        this._app.stage.addChild(this.stackContainer);
        this._dragonContainer.interactive = true;
        this._dragonContainer.on("pointerdown", this.hatchEgg.bind(this));
        this._dragonContainer.setIdleAnimation();
        this._backdropContainer.dragonSlot.addChild(this._dragonContainer);
        this.titleLabel.text = i18next_1.default.t("hatch_caption");
        this.tipLabel.text = i18next_1.default.t("hatch_hint");
        this.stackContainer.layoutChildren();
        this._client.sendEvent("hatch_entered");
    };
    HatchState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this._backdropContainer);
        this._app.stage.removeChild(this.evolveEmitter.parent);
        this._app.stage.removeChild(this.stackContainer);
        this.evolveEmitter.emit = false;
        this.evolveEmitter.cleanup();
        this._dragonContainer.interactive = false;
        this._dragonContainer.off("pointerdown");
        this._backdropContainer.dragonSlot.removeChild(this._dragonContainer);
    };
    HatchState.prototype.hatchEgg = function () {
        this._dragonContainer.interactive = false;
        var evolvePosition = this._app.stage.toLocal(new PIXI.Point(0, -300), this._dragonContainer);
        this.evolveEmitter.updateSpawnPos(evolvePosition.x, evolvePosition.y);
        this.evolveEmitter.emit = true;
        gsap_1.gsap.to(this, {
            duration: 1,
            onComplete: this.finished.bind(this)
        });
    };
    HatchState.prototype.finished = function () {
        var _this = this;
        this.evolveEmitter.emit = false;
        var now = new Date();
        var meters = this._client.dragon.meters;
        meters.calmness = calculator_1.METER_START_CALMNESS;
        meters.nutrition = calculator_1.METER_START_NUTRITION;
        meters.hygiene = calculator_1.METER_START_HYGIENE;
        meters.energy = calculator_1.METER_START_ENERGY;
        this._client.dragon.status.saved = now;
        this._client.dragon.status.stage = 1;
        this._client.synchronize();
        this._client.sendEvent("hatch_finished");
        this._dragonContainer.setHatched(true);
        this._dragonContainer.setIdleAnimation();
        gsap_1.gsap.to(this, {
            duration: 2,
            onComplete: function () {
                var pages = [
                    [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_hatched_1")),
                        new guide_1.GuideMessage(i18next_1.default.t("guide_hatched_2")),
                    ], [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_hatched_3")),
                        new guide_1.GuideMessage(i18next_1.default.t("guide_hatched_4"))
                    ], [
                        new guide_1.GuideMessage(i18next_1.default.t("guide_hatched_5")),
                        new guide_1.GuideMessage(i18next_1.default.t("guide_hatched_6")),
                        new guide_1.GuideMessage(i18next_1.default.t("guide_hatched_7"))
                    ]
                ];
                _this._guide.setPages(pages);
                _this.stateMachine.pop();
                _this.stateMachine.push(guide_state_1.default);
            }
        });
    };
    return HatchState;
}(state_1.default));
exports.default = HatchState;
